import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { roundDecimal, formatCalendarDate } from "../../../../utils/helperFunctions";
import CommonLoadingIndicator from "./CommonLoadingIndicator";

type TableProps = {
  data: Array<Object>;
};

const DATAGRID_INITIAL_STATE = {
  pagination: {
    paginationModel: {
      pageSize: 10,
    },
  },
};

const dateSortComparator = (_v1: string, _v2: string, params1: any, params2: any) => {
  const raw1 = params1.api.getRow(params1.id)?.rawDateTime || "";
  const raw2 = params2.api.getRow(params2.id)?.rawDateTime || "";
  return raw1.localeCompare(raw2);
};

const columns = [
  { field: "date", headerName: "Date (UTC)", width: 200, sortComparator: dateSortComparator },
  { field: "calories", headerName: "Calories", width: 200 },
];

export function transformDataToRows(data: Array<Object>) {
  return data.map((value: any) => {
    return {
      id: value.$id,
      date: formatCalendarDate(value.consumedDate),
      rawDateTime: value.consumedDate || "",
      calories: roundDecimal(
        value.energyKcal || (value.energyKj > 0 ? value.energyKj / 4.184 : "0")
      ),
    };
  });
}

function CaloriesTable({ data }: TableProps) {
  const [tableRows, setTableRows] = useState<Array<Object>>();

  useEffect(() => {
    try {
      if (!data) return;
      const transformedData = transformDataToRows(data);
      setTableRows(transformedData);
    } catch (error) {
      console.error(error);
    }
  }, [data]);

  if (tableRows && data) {
    return (
      <DataGrid
        rows={tableRows}
        columns={columns}
        initialState={DATAGRID_INITIAL_STATE}
        checkboxSelection
        disableRowSelectionOnClick
        pageSizeOptions={[10, 25, 50, 100]}
      />
    );
  } else {
    return <CommonLoadingIndicator />;
  }
}

export default CaloriesTable;
